import { ActionType } from './action';

const usersReducer = (users = [], action = {}) => {
  switch (action.type) {
    case ActionType.SET_RECEIVE_USERS:
      return action.payload.users;
    default:
      return users;
  }
};

export default usersReducer;
